import * as React from 'preact/compat'

import { disableScroll, enableScroll, loadStylesheet, wait } from '#js/common/helpers'

import SearchPanel from '#components/Search/SearchPanel'

import styles from '#css/search-panel.pcss.json'
import headerStyles from '#css/header.pcss.json'

declare global {
  interface Window {
    searchShown: boolean;
  }

  interface HTMLButtonElement {
    searchPanelAttached?: boolean;
  }
}

let container: HTMLDivElement = undefined
window.searchShown = false

type SearchTabs = 'games' | 'users' | 'news' | 'blogs' | 'articles' | 'video' | 'cheats' | 'comments' | 'faq'

const createPanel = async (currentTab: SearchTabs) => {
  await loadStylesheet('search-panel')
  container = document.createElement('div')
  document.body.append(container)
  React.render(<SearchPanel currentTab={currentTab} close={hidePanel}/>, container)
  await wait(100)
  document.querySelector<HTMLInputElement>('[data-search-input-container]').style.transform = 'translateY(0)';
  container.querySelector(`.${styles['overlay']}`).classList.add(styles['overlay--in'])
}

const goIntoPanel = (ev: KeyboardEvent) => {
  if (ev.key === 'Tab' && !ev.shiftKey) {
    ev.preventDefault()
    document.querySelector<HTMLInputElement>(`.${styles['search-input__input']}`).focus()
  }
}

const hidePanel = async () => {
  if (!window.searchShown) {
    return
  }
  window.searchShown = false
  if (container) {
    container.querySelector(`.${styles['overlay']}`).classList.remove(styles['overlay--in'])
    const desktopInput = document.querySelector<HTMLInputElement>('[data-search-input-container]')
    desktopInput.style.transform = ''
    desktopInput.querySelector('input').value = ''
  }
  await wait(300)
  enableScroll()
  if (container) {
    React.unmountComponentAtNode(container)
    container.remove()
  }
  container = undefined
  const icon = document.querySelector(`.${headerStyles['header__search-btn__icon']}`)
  icon.innerHTML = '<use href="#sg-new/search-large"></use>'
  const button = document.querySelector(`.${headerStyles['header__search-btn']}`)
  button.removeEventListener('keydown', goIntoPanel)
}

const showPanel = async (currentTab: SearchTabs) => {
  if (window.matchMedia('(min-width: 421px)').matches) {
    window.dispatchEvent(new Event('close-all-menus'))
  }
  window.searchShown = true
  await wait(10)
  disableScroll()
  await createPanel(currentTab)
  const icon = document.querySelector(`.${headerStyles['header__search-btn__icon']}`)
  icon.innerHTML = '<use href="#sg-new/cross-large"></use>'
  const button = document.querySelector(`.${headerStyles['header__search-btn']}`)
  button.addEventListener('keydown', goIntoPanel)
}

export default (elements: NodeListOf<HTMLButtonElement>) => {
  window.addEventListener('close-all-menus', hidePanel)

  elements.forEach(element => {
    if (element.searchPanelAttached) {
      return
    }

    const currentTab = element.getAttribute('data-search-section') ?? 'games'

    element.addEventListener('click', async (ev: MouseEvent) => {
      ev.stopImmediatePropagation()
      ev.preventDefault()
      if (window.searchShown) {
        // noinspection ES6MissingAwait
        hidePanel()
      } else {
        await showPanel(currentTab as SearchTabs)
      }
    })
    element.searchPanelAttached = true
  })
}
